// extracted by mini-css-extract-plugin
export default {"activedfdf":"Navbar_activedfdf__egNBe","active":"Navbar_active__ncCM8"};